/**
 * @fileoverview Preserve an eligible in-app destination across sign-in and onboarding. Browser storage owns navigation intent while `AuthContext.js` owns identity and backend authentication owns session acceptance. Restoring a remembered route does not grant its workspace or resource permissions.
 */

const POST_LOGIN_REDIRECT_KEY = 'postLoginRedirectPath'



export function buildPostLoginRedirectPath(fromLocation, existingRedirectPath = null) {
    if (fromLocation && typeof fromLocation.pathname === 'string') {
        const pathname = fromLocation.pathname || '/'
        const search = fromLocation.search || ''
        const hash = fromLocation.hash || ''

        return `${pathname}${search}${hash}`
    }

    return existingRedirectPath || '/'
}



export function storePostLoginRedirectPath(fromLocation, existingRedirectPath = null) {
    const redirectPath = buildPostLoginRedirectPath(fromLocation, existingRedirectPath)
    localStorage.setItem(POST_LOGIN_REDIRECT_KEY, redirectPath)
    return redirectPath
}



export function getStoredPostLoginRedirectPath() {
    return localStorage.getItem(POST_LOGIN_REDIRECT_KEY) || '/'
}



export function clearStoredPostLoginRedirectPath() {
    localStorage.removeItem(POST_LOGIN_REDIRECT_KEY)
}
